// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 966) return "static/chunks/966-01f38e873aed56f5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"12":"42d7bb66c2dfa282","67":"707743d5c007d4d8","189":"bda8b634a0a767a2","426":"02c32ecaaf34da04","923":"e7f660a7af144cb0","943":"8e3ae2511201f7ee"}[chunkId] + ".js";
};